import { useState } from 'react'
import { Dropdown } from 'src/components/Dropdown'
import { Search } from './components'
import { Exceptions } from './components/Search/Exceptions'
import styles from './styles.module.scss'
import sortBy from 'lodash/sortBy'
import useWidth from 'src/hooks/useWidth'
import { Button } from 'src/360ui'

export type HideNftFilterProps = {
  addItem: (item: string[]) => void
  removeItem: (item: string[]) => void
  currentItemsDict: any
  reset: () => void
  data: any
  setExceptions
  setDataFilter
}

export const HideNftFilter = ({
  addItem,
  removeItem,
  reset,
  currentItemsDict = [],
  data,
  setExceptions,
  setDataFilter,
}: HideNftFilterProps) => {
  const { isMobile } = useWidth()
  const [open, setOpen] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const onSearchValueChange = event => setSearchValue(event.target.value)
  const onAddItem = item => {
    const aux = currentItemsDict.map(item => item.address)
    addItem([...aux, item.address])
    setExceptions([...currentItemsDict, item])
    let auxData = data.filter(l => {
      if (l.address !== item.address) return l
    })

    auxData = sortBy(auxData || [], [d => d.volume])
      .reverse()
      .map((item, index) => ({
        ...item,
        index: index + 1,
      }))

    setDataFilter(auxData)
  }
  const onRemoveItem = (exceptions, exception) => {
    const aux = exceptions.map(item => item.address)
    removeItem(aux)
    setExceptions(exceptions)
    let auxData = [...data, exception]

    auxData = sortBy(auxData || [], [d => d.volume])
      .reverse()
      .map((item, index) => ({
        ...item,
        index: index + 1,
      }))
    setDataFilter(auxData)
  }
  const onClearAll = () => {
    let auxData = [...data, ...currentItemsDict]

    auxData = sortBy(auxData || [], [d => d.volume])
      .reverse()
      .map((item, index) => ({
        ...item,
        index: index + 1,
      }))
    setDataFilter(auxData)
    setExceptions([])
    reset()
  }

  const num = currentItemsDict.length

  return isMobile ? (
    <>
      <Button
        variant='tertiary'
        onPress={() => setOpen(!open)}
        className={styles.btn}
      >
        <span>Hide </span>
        <span className={styles.active}>
          {num} {num <= 1 ? 'NFT' : 'NFTs'}
        </span>
      </Button>

      {open && (
        <div className={styles.container}>
          <Search
            reset={onClearAll}
            selectedBlock={
              <Exceptions
                currentItemsDict={currentItemsDict}
                deleteItem={onRemoveItem}
              />
            }
            placeholder='Search'
            list={data}
            searchValue={searchValue}
            onSearchChange={onSearchValueChange}
            onSelectItem={onAddItem}
          />
        </div>
      )}
    </>
  ) : (
    <Dropdown
      title={
        <>
          <span className={styles.title}>Hide </span>
          {num > 0 && <span className={styles.active}>({num})</span>}
        </>
      }
      showArrow
      buttonClassName={styles.buttonClassName}
      titleBlock={undefined}
      wrapperClassName={undefined}
      listClassName={undefined}
      currencyLogo={undefined}
    >
      <Search
        reset={onClearAll}
        selectedBlock={
          <Exceptions
            currentItemsDict={currentItemsDict}
            deleteItem={onRemoveItem}
          />
        }
        placeholder='Search'
        list={data}
        searchValue={searchValue}
        onSearchChange={onSearchValueChange}
        onSelectItem={onAddItem}
      />
    </Dropdown>
  )
}
